export default __webpack_public_path__ + "static/media/basic-pin-large-15.7f4dcc36.png";